import styles from './devicesModelsTabPage.module.css';

import editIcon from 'assets/svg/edit-01.svg';
import deleteIcon from 'assets/svg/delete-01.svg';
import addIcon from 'assets/svg/add-01.svg';

import { observer } from 'mobx-react-lite';
import React, { useRef, useState } from 'react';
import Table, { TableActionButtons, TableToolbarButtons } from 'widgets/Table';
import ExpandedRow from 'widgets/Table/ExpandedRow';
import ActionButton from 'ui/ActionButton';
import useAlert from 'hooks/useAlert';
import { devicesModelsStore } from 'store/mobx/devicesModels.store';
import DeviceModelUpsertModal from './DeviceModelUpsertModal/DeviceModelUpsertModal';

const DevicesModels = observer(({ mode }) => {
  const {
    devicesModels,
    pagination,
    columns,
    setDevicesModels,
    removeDeviceModel,
    setStateDeviceModel,
  } = devicesModelsStore;
  const { showAlert } = useAlert();
  const tableRef = useRef(null);
  const [addDeviceModelModal, setAddDeviceModelModal] = useState(false);

  const addNewDevice = () => {
    setStateDeviceModel(null);
    setAddDeviceModelModal(true);
  };

  const editDevice = (value) => {
    setStateDeviceModel(value);
    setAddDeviceModelModal(true);
  };

  const deleteDevice = async (value) => {
    sureDeleteModelAlert(async () => {
      const result = await removeDeviceModel(value.id);
      if (!result.success) return errorHandler(result.error_code, result.error);
      successDeviceModelDeleteAlert();
    });
  };

  const onTableUpdate = async (options) => {
    await setDevicesModels(options);
  };

  const successDeviceModelDeleteAlert = () =>
    showAlert(`Модель оборудования удалена успешно!`, 'success');

  const errorHandler = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  const sureDeleteModelAlert = (callbacks) => {
    showAlert(`Вы действительно хотите удалить данную модель оборудования?`, 'sure', callbacks);
  };

  return (
    <div className={styles.pageContainer}>
      <Table
        initialColumns={columns}
        initialRows={devicesModels}
        totalItems={pagination.itemsCount}
        itemsPerPage={pagination.limit}
        page={pagination.page}
        ref={tableRef}
        onUpdate={onTableUpdate}
        isExpandable
      >
        <TableToolbarButtons>
          <ActionButton
            icon={addIcon}
            styleConfig={{
              container: styles.toolbarActionButtonContainer,
              iconContainer: styles.toolbarActionButton,
              tooltipText: 'Добавить',
            }}
            color="#fff"
            onClick={addNewDevice}
          />
        </TableToolbarButtons>
        <TableActionButtons>
          <ActionButton
            icon={editIcon}
            styleConfig={{
              iconContainer: styles.actionButtonIconContainer,
              tooltipText: 'Редактировать',
            }}
            onClick={editDevice}
          />
          <ActionButton
            icon={deleteIcon}
            styleConfig={{
              iconContainer: styles.actionButtonIconContainer,
              tooltipText: 'Удалить',
            }}
            onClick={deleteDevice}
          />
        </TableActionButtons>
        <ExpandedRow rowExpandedPrepared={(row) => ModelsDeviceDetails(row)} />
      </Table>
      {addDeviceModelModal && (
        <DeviceModelUpsertModal setModalOpened={setAddDeviceModelModal} mode={mode} />
      )}
    </div>
  );
});

const ModelsDeviceDetails = (row) => (
  <div className={styles.modelDeviceDetails}>
    <div className={styles.blockTitle}>Пользовательские параметры</div>
    <div className={styles.regularText}>
      {row.user_fields?.map((field) => field.name).join(', ')}
    </div>
    <div className={styles.blockTitle}>Характеристики</div>
    <table className={styles.table}>
      <tbody>
        {row.specifications?.map((spec, index) => (
          <tr key={index}>
            <td className={styles.cell}>{spec.name}</td>
            <td className={styles.cell}>{spec.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DevicesModels;
